/* 🤖 this file was generated by svg-to-ts */
export const DfIconPerson16: {
  name: 'person-16';
  data: string;
} = {
  name: 'person-16',
  data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22.625 22.775c.4-.125.65-.525.55-.95-.5-2.35-1.8-3.6-3.575-4.725-.5-.3-1.1-.55-1.75-.825-1.225-.475-2.6-1.025-2.9-1.95-.175-.6.075-1.425.75-2.475 2.075-3.35 2.45-6.25 1.1-8.575C15.75 1.475 13.975.4 12 .4c-1.95 0-3.75 1.075-4.8 2.875C5.85 5.6 6.225 8.5 8.325 11.85c.675 1.05.925 1.875.725 2.475-.3.925-1.675 1.475-2.875 1.95-.675.275-1.3.525-1.775.825-1.775 1.125-3.075 2.375-3.575 4.725-.1.425.15.825.55.95.1.025 2.85.825 10.625.825 3.875 0 6.5-.2 8.175-.4s2.4-.425 2.45-.425z"/></svg>`
};
